// extracted by mini-css-extract-plugin
module.exports = {"localeSelect":"localeSelect--3zmRd","countryFlag":"countryFlag--1cCcb"};